// Helpers shared by the quality check list and the compare view.

const VIDEO = /\.(mp4|mov|webm|m4v)(\?|$)/i;

export const isVideo = (item) =>
  item?.mime_type?.startsWith("video") || VIDEO.test(item?.url || "");

// Factory pictures uploaded by the team. Older products only have one picture.
export const factoryPictures = (product) => {
  if (product?.factory_pictures?.length) return product.factory_pictures;
  if (product?.factory_picture && product.factory_picture !== "Not available") {
    return [
      {
        url: product.factory_picture,
        mime_type: product?.quotation_request?.options?.option1MimeType,
      },
    ];
  }
  return [];
};

// The merchant's own pictures: one per variant that has an image, then any
// product image no variant uses.
export const productPictures = (product) => {
  const seen = new Set();
  const items = [];
  for (const variant of product?.variants || []) {
    if (!variant?.img || seen.has(variant.img)) continue;
    seen.add(variant.img);
    items.push({ url: variant.img, label: variant.title });
  }
  for (const image of product?.images || []) {
    if (!image?.src || seen.has(image.src)) continue;
    seen.add(image.src);
    items.push({ url: image.src, label: "" });
  }
  return items;
};

export const qualityStatus = (product) => {
  const ready = factoryPictures(product).length > 0;
  const requested = product?.requote_request === "SENT";
  if (ready && requested) return { key: "requote", label: "Requote requested" };
  if (ready) return { key: "ready", label: "Ready to check" };
  if (requested) return { key: "waiting", label: "Pictures requested" };
  return { key: "none", label: "Not available" };
};
